export default class SiteViewModel {
  constructor(response) {
    this.id = response.id;
    this.organizationId = response.organizationId;
    this.title = response.title;
    this.description = response.description;
    this.isActive = response.isActive;
    this.createdByName = response.createdByName;
    this.createdAt = response.createdAt;
    this.etag = response.etag;
  }
}
